import React from 'react';
import { debounce } from '@mui/material';

const getGridElement = (current: SVGElement | { current: SVGElement } | null) => {
  const node = current instanceof SVGElement ? current : current?.current;
  const grid = node?.querySelector?.('.recharts-cartesian-grid');
  return grid instanceof SVGElement ? grid : null;
};

const getSize = (node: SVGElement | null) => {
  const { width = 0, height = 0 } = node?.getBoundingClientRect() || {};
  return { width, height };
};

const calcInterval = (size: number, totalTicks: number, minTickWidth: number) => {
  if (!size || !totalTicks || !minTickWidth) {
    return 0;
  }
  const numOfTicks = Math.floor(size / minTickWidth);
  const interval = Math.floor(totalTicks / numOfTicks);
  return interval;
};

export const useAvComposedWidgetInterval = ({
  totalXTicks,
  totalYTicks,
  minXTickSize,
  minYTickSize,
}: {
  totalXTicks: number;
  totalYTicks: number;
  minXTickSize: number;
  minYTickSize: number;
}) => {
  const responsiveContainerRef = React.useRef<SVGElement | { current: SVGElement }>(null);
  const [, setContainerSize] = React.useState<{ w: number; h: number }>({ w: 0, h: 0 });
  const handleResize = debounce((w: number, h: number) => setContainerSize({ w, h }));

  const { height, width } = getSize(getGridElement(responsiveContainerRef.current));

  const intervalX = calcInterval(width, totalXTicks, minXTickSize);
  const intervalY = calcInterval(height, totalYTicks, minYTickSize);

  return { intervalX, intervalY, handleResize, responsiveContainerRef };
};
